import { TAGS } from "../constants";
import { CreatePrice, ProductPrice, UpdatePrice } from "../types";
import { api } from "./api";

export const pricesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createPrice: builder.mutation<ProductPrice, CreatePrice>({
      query: (body) => ({ method: "POST", url: `/api/products/prices`, body }),
      invalidatesTags: (_returns, _error, args) => [
        { type: TAGS.PRODUCT_PRICES, id: args.product_slug },
      ],
    }),
    updatePrice: builder.mutation<ProductPrice, UpdatePrice>({
      query: ({ id, ...body }) => ({
        method: "PUT",
        url: `/api/products/prices/${id}`,
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        { type: TAGS.PRODUCT_PRICES, id: args.product_id },
      ],
    }),
    getPrice: builder.query<ProductPrice, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/products/prices/${id}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PRODUCT_PRICE, id: args },
      ],
    }),
  }),
});

export const {
  useCreatePriceMutation,
  useUpdatePriceMutation,
  useGetPriceQuery,
} = pricesApi;
